import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import styled, { useTheme } from "styled-components";

import { Divider } from "../../../../../commonStyles";
import { useContainerSize } from "../../../../../hooks/useContainerSize";
import { FlexColumn } from "../../../../Common/Styles";
import { ExistingPods } from "./ExistingPods";
import { RecommendedPods } from "./RecommendedPods";
import { TitleAndButton } from "./TitleAndButton";

export const Pods = () => {
  const { Color } = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  const { height } = useContainerSize(ref);
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Container $gapInPx={8} $height={isOpen ? height + 48 : 40}>
      <TitleAndButton isOpen={isOpen} setIsOpen={setIsOpen} />
      <FlexColumn $gapInPx={8} ref={ref}>
        <Divider $color={Color.border["ui-border-subtle"].value} />
        <ExistingPods />
        <Divider $color={Color.border["ui-border-subtle"].value} />
        <RecommendedPods />
      </FlexColumn>
    </Container>
  );
};

const Container = styled(FlexColumn)<{ $height: number }>`
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  max-height: ${({ $height }) =>
    ThisGorillaUtils.convertPxToRem(String($height))}rem;
  transition: max-height 300ms ease-in-out;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #ffffff00 0%,
    hsla(206, 89.1%, 53.3%, 0.08) 100%
  );
`;
